<template>
  <main>
    <!-- Modal Structure -->
    <div id="modalScan" class="modal">
      <div class="modal-content">
        <i style="right: 1rem; position: absolute; top: 1rem; cursor: pointer" class="material-icons tooltipped"
           data-position="bottom"
           data-tooltip="Cerrar"
           @click="closeScan"
           id="caramaCerrar"
        >close</i>
        <inputScan v-if='isScan' @onScan="setIcc"></inputScan>
      </div>
    </div>

    <div class="row right-align main" >
      <div class="col s12 m12 l4   ">
        <div class="card-panel" v-if="fIsControler('Recargas')">
          <h4 class="titulo" style="text-align: center;" >Recargar</h4>
          <label v-show="foreignRecharge">
            <input type="checkbox" v-model="foreignOption"/>
            <span>Recarga externa</span>
          </label>
          <form>
            <div v-if="isPlataformas">
              <label>Plataforma</label>
              <div class="switch">
                <label>
                  {{ plataforma1 }}
                  <input
                      type="checkbox"
                      :checked="noPlataforma == 2"
                      @change="cambiarPlataforma"
                  />
                  <span class="lever"></span>
                  {{ plataforma2 }}
                </label>
              </div>
            </div>
            <div class="input-field col s12">
              <i
                  class="fa fa-building prefix icono-izquierda"
                  aria-hidden="true"
              ></i>

              <select v-model="tipoRecarga">
                <option value="ICC">Por icc</option>
                <option value="DN">Por dn</option>
              </select>
              <label>Tipo de recarga</label>
            </div>

            <div v-show="tipoRecarga === 'ICC'" class="input-field col s9 m10">
              <i class="material-icons prefix icons-down" aria-hidden="true"
              >sim_card</i
              >
              <input
                  v-model="icc"
                  id="icc"
                  type="tel"
                  maxlength="19"
                  class="validate"
              />
              <label id="labelIcc" for="icc">Icc</label>

            </div>
            <div v-show="tipoRecarga === 'ICC'" class=" input-field col s2 " style="margin-top: 1.7rem" v-if="empresa== 'demo' || empresa== 'gsmoviles' || empresa== 'teletrial'" >
              <div
                  class="waves-effect waves-light btn tooltipped blue-grey darken-3 modal-trigger"
                  data-position="bottom"
                  data-tooltip="Usar Camara"
                  href="#modalScan"
                  id="camaraTooltip"
              >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=photo_camera"/>
                <span class="material-symbols-outlined btn-style">
                photo_camera
              </span>
              </div>

            </div>
            <div v-show="tipoRecarga === 'ICC'" class="input-field col s12">
              <i
                  class="fa fa-check-circle prefix icons-down"
                  aria-hidden="true"
              ></i>
              <input
                  v-model="confirmacionIcc"
                  id="confirmacion-icc"
                  type="tel"
                  maxlength="19"
                  class="validate"
              />
              <label id="labelConfirmaIcc" for="confirmacion-icc">Confirmación de icc</label>
            </div>


            <!--          <div v-show="tipoRecarga === 'ICC'" class=" input-field col s2"  style="margin-top: 1.7rem">-->
            <!--            <div-->
            <!--                class="waves-effect waves-light btn tooltipped blue-grey darken-3 modal-trigger"-->
            <!--                data-position="bottom"-->
            <!--                data-tooltip="Usar Camara"-->
            <!--                href="#modalScan"-->
            <!--            >-->
            <!--              <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=photo_camera" />-->
            <!--              <span class="material-symbols-outlined btn-style">-->
            <!--                photo_camera-->
            <!--              </span>-->
            <!--            </div>-->

            <!--          </div>-->

            <div
                v-show="tipoRecarga === 'DN' || hasMoviDnPermit"
                class="input-field col s12"
            >
              <i class="fa fa-phone prefix icons-down" aria-hidden="true"></i>
              <input
                  v-model="telefono"
                  id="telefono"
                  type="tel"
                  maxlength="10"
                  class="validate"
              />
              <label for="telefono">Número telefonico</label>
            </div>
            <div v-show="tipoRecarga === 'DN'" class="input-field col s12">
              <i
                  class="fa fa-check-circle prefix icons-down"
                  aria-hidden="true"
              ></i>
              <input
                  v-model="confirmacionTel"
                  id="confirmacion-telefono"
                  type="tel"
                  maxlength="10"
                  class="validate"
              />
              <label for="confirmacion-telefono">Confirmación de número</label>
            </div>
            <div v-show="foreignOption" class="input-field col s12">
              <i class="fa fa-list-ol prefix icons-down" aria-hidden="true"> </i>
              <input
                  v-model="folio"
                  id="folio"
                  type="tel"
                  maxlength="10"
                  class="validate"
              />
              <label for="folio">Folio de recarga</label>
            </div>

            <div v-if="sendMonto" class="input-field col s12">
              <i
                  class="fa fa-dollar-sign prefix icono-izquierda"
                  aria-hidden="true"
              ></i>
              <select v-model="montoSeleccionado">
                <option value="0" disabled>opcional</option>
                <option value="1">30</option>
                <option value="2">50</option>
                <option value="3">70</option>
                <option value="4">100</option>
                <option value="5">200</option>
              </select>
              <label>Monto de recarga</label>
            </div>
            <span class="mensaje-error col s12">{{ mensaje }}</span>
            <div v-show="isRecargando" class="progress barraMovimientos">
              <div class="indeterminate"></div>
            </div>
            <div v-show="!isRecargando" class="barra-invisible"></div>
            <div>
              <div class="col s12" style="text-align-last: justify;">
                <div
                    v-show="!isRecargando"
                    class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                    @click="limpiar"
                    data-position="bottom"
                    data-tooltip="Limpiar campos"
                >
                  <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
                  />
                  <span class="material-symbols-outlined btn-style">
                  mop
                </span>
                </div>
                <div
                    v-show="!isRecargando"
                    class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                    @click="enviar"
                    data-position="bottom"
                    data-tooltip="Recargar"
                >
                  <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
                  />
                  <span class="material-symbols-outlined btn-style">
                  security_update_good
                </span>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>
      <!--          <div-->
      <!--               class="col s10  waves-effect waves-light btn-large #546e7a blue-grey darken-1 push-s1 main"-->
      <!--               @click="sendNoti"><i class="fa fa-trash left" aria-hidden="true"></i> SEnd-->
      <!--          </div>-->
      <div class="col s12 m12 l8  ">
        <div class="row">
          <div class="col s12 m12  ultimos ">
            <div class="card-panel" v-if="fIsControler('movimientos')">
              <span class="titulo center-align">Últimos 10 movimientos</span>
              <table class="striped">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Estatus</th>
                  <th>Fecha</th>
                  <th>Compañia</th>
                  <th>Numero</th>
                  <th v-if="!(empresa == 'discovery' && !isAdmin) ">Monto</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(movimiento, index) in movimientos">
                  <td>{{ 10 - index }}</td>
                  <td>{{ movimiento.estatus }}</td>
                  <td>{{ movimiento.fecha }}</td>
                  <td>{{ movimiento.compania }}</td>
                  <td>{{ movimiento.dn }}</td>
                  <td v-if="!(empresa == 'discovery' && !isAdmin)">{{ movimiento.monto }}</td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col  s12 m12 ">
            <div class="row">
              <div class="col s12  l6   " v-show="isActivaciones">
                <div class="  card-panel" style="height: auto" v-if="fIsControler('Estatus')">
                  <span class="titulo center-align">Estatus ICC ATT</span>
                  <div>
                    <form @submit.prevent="enviarActivacion">
                      <div class="input-field col s12">
                        <i class="material-icons prefix icons-down" aria-hidden="true"
                        >sim_card</i
                        >
                        <input
                            v-model="iccActivacion"
                            id="iccActivacion"
                            type="tel"
                            maxlength="19"
                            class="validate"
                        />
                        <label for="iccActivacion">Icc</label>
                      </div>
                      <div class="col s12">
                        <div
                            v-show="!isActivado"
                            class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                            data-position="bottom"
                            data-tooltip="Buscar"
                            @click="enviarActivacion"
                        >
                          <link
                              rel="stylesheet"
                              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
                          />
                          <span class="material-symbols-outlined btn-style">
                          search
                        </span>
                        </div>
                      </div>
                      <div>
                        <span class="mensaje-error col s12">{{ mensajeActivacion }}</span>
                        <div v-show="isActivado" class="progress barraMovimientos">
                          <div class="indeterminate"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col s12  l6   " v-show="isLineasRecicladas" >
                <div class="card-panel" v-if="fIsControler('Reciclar')">
                  <span class="titulo center-align">Reciclar Lineas</span>
                  <form>
                    <div class="input-field col s12">
                      <i class="fa fa-phone prefix icons-down" aria-hidden="true"></i>
                      <input
                          v-model="dnReciclar"
                          id="dnReciclar"
                          type="tel"
                          maxlength="19"
                          class="validate"
                      />
                      <label for="dnReciclar">Dn</label>
                    </div>
                    <div class="col s12">
                      <div
                          class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                          data-position="bottom"
                          data-tooltip="Reciclar linea"
                          @click="enviarDnReciclar"
                      >
                        <link
                            rel="stylesheet"
                            href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
                        />
                        <span class="material-symbols-outlined btn-style">
                recycling
              </span>
                      </div>
                    </div>
                    <div>
                      <span class="mensaje-error col s12"></span>
                      <div v-show="isActivado" class="progress barraMovimientos">
                        <div class="indeterminate"></div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>

    </div>
  </main>
</template>

<script>
import {recargar, recargaExterna, reciclarLineas} from "@/api/api";
import {getMovimientos, getEmpresas, cambiarEmpresa} from "../api/api";
import {permisos, controles} from "@/constantes";
import {mapState} from "vuex";
import {sendNotification, statusActivacion} from "@/api/firebase";
import inputScan from "./inputScan"

let modal

export default {
  name: "recargaa",
  data() {
    return {
      miNivel: localStorage.nivel,
      companias: [],
      isScan: false,
      mensaje: " ",
      telefono: "",
      confirmacionTel: "",
      confirmacionIcc: "",
      icc: "",
      tipoPeticion: "todito",
      movimientos: [],
      titulos: [],
      iccActivacion: "",
      dnReciclar: "",
      tipoRecarga: "ICC",
      montoSeleccionado: "0",
      isRecargando: false,
      isActivado: false,
      foreignOption: false,
      folio: "",
      mensajeActivacion: "",
      mensajeDnReciclado: "",
      plataforma1: ``,
      plataforma2: ``,
      noPlataforma: 1,
      empresa: window.localStorage.getItem('empresa')
    };
  },
  components: {
    inputScan: inputScan
  },
  created() {
    this.$nextTick(() => {

      console.log(`contriler 1`)
      const empresa = controles[`${this.empresa}`]
      if (!empresa) return true
      console.log(`contriler 2`)
      const user = empresa.find(e => e.user == localStorage.username)
      if (!user) return true
      console.log(`contriler 3`)
      const rutaValida = user.rutas.find(r => r == 'recargas')
      if (rutaValida) return true
      else {
        console.log(`contriler`)
        this.$router.push({name: user.rutas[0]});
      }

    })
  },
  mounted() {




    this.$nextTick(() => {

      console.log(navigator.userAgent, navigator.geolocation)

      this.getMovements();

      getEmpresas()
          .then((resp) => {
            console.log(resp);
            this.plataforma1 = resp.data.plataforma;
            this.plataforma2 = resp.data.plataforma2;
            this.noPlataforma = resp.data.noPlataforma;
          })
          .catch((error) => {
            console.log(error);
          });

      M.AutoInit()
      setTimeout(() => {
        const elem = document.getElementById('modalScan')
        //const modal = M.Modal.getInstance(elem);
        modal = M.Modal.init(elem, {
          onOpenStart: () => {
            const modal = document.getElementById('modalScan')
            console.log(document.documentElement.scrollWidth)
            if (document.documentElement.scrollWidth > 600)
              modal.style.width = `30vw`
            console.log(`se esta abriendo`)
            this.isScan = true
          },
          onOpenEnd: () => {
            const elemetTooltip = document.getElementById('camaraTooltip')
            const camaraTooltip = M.Tooltip.getInstance(elemetTooltip);
            camaraTooltip.close()
          },
          onCloseStart: () => {
            console.log(`se esta cerrando`)
            this.isScan = false
          },
          onCloseEnd: () => {
            const elemetTooltip = document.getElementById('caramaCerrar')
            const camaraTooltip = M.Tooltip.getInstance(elemetTooltip);
            camaraTooltip.close()
          },
        })
        console.log(modal, `este es el modal op`)

      }, 1000)

    })
  },
  methods: {

    fIsControler(ruta) {
      console.log(this.miNivel, `mi nivkel`)
      if (this.miNivel != 1) {
        console.log(`en le nivel subida`)
        return true
      }
      const empresa = controles[`${this.empresa}`]
      if (!empresa) {
        console.log(`en la empresa subida`)
        return true
      }
      const user = empresa.find(e => e.user == localStorage.username)
      if (!user) {
        console.log(`en el user subida`)
        return true
      }
      if(!user.permisosRecargas) {
        console.log(`en los permisos subida`)
        return true
      }
      const rutaValida = user.permisosRecargas.find(r => r == ruta)
      if (rutaValida) {
        console.log(`en la ruta subida`)
        return true
      }

      return false
    },
    setIcc(icc) {
      const elem = document.getElementById('modalScan')
      const modal = M.Modal.getInstance(elem);
      modal.close();
      if(icc.text){
        const ultimo = icc.text.substring(icc.text.length-1, icc.text.length)
        this.confirmacionIcc = ultimo == 'f' || ultimo == 'F' ? icc.text.substring(0, icc.text.length-1) : icc.text
        this.icc =  ultimo == 'f' || ultimo == 'F' ? icc.text.substring(0, icc.text.length-1) : icc.text
        const labelIcc = document.getElementById('labelIcc')
        const labelConfirmaIcc = document.getElementById('labelConfirmaIcc')
        labelIcc.className = 'active'
        labelConfirmaIcc.className = 'active'
      }
    },
    closeScan() {
      const elem = document.getElementById('modalScan')
      const modal = M.Modal.getInstance(elem);

      modal.close();
    },
    openScan() {
      console.log(`asda`)
      // const elem = document.getElementById('modalScan')
      // const modal = M.Modal.getInstance(elem);
      //this.isScan = true
      //modal.open();

    },
    enviarActivacion() {
      statusActivacion(this.iccActivacion)
          .then((resp) => {
            console.log(resp);
            if (resp.ResponseCode == 0)
              this.mensajeActivacion = `DN: ${resp.dnPermanente},
            Fecha de creacion: ${resp.fechaCreacion},
            Organización: ${resp.organizacion},
            Subinventario: ${resp.subinventario},
            Marca: ${resp.marca},
            Kit: ${resp.kit}`;
            else
              this.mensajeActivacion = `Problema al obtener el estautus, icc no activo aún, o no pertenece a tu inventario.`;
          })
          .catch((error) => {
            console.log(error);
            this.mensajeActivacion = error;
          });
    },
    enviarDnReciclar() {
      let objetoaEnviar = {};
      objetoaEnviar.dnReciclar = this.dnReciclar;
      console.log("eee", objetoaEnviar.dnReciclar);

      reciclarLineas(objetoaEnviar)
          .then((respuesta) => {
            console.log(respuesta);
            M.toast({
              html: `Dn reciclado`,
              classes: "rounded",
              displayLength: 3000,
            });
          })
          .catch((error) => {
            console.log(error);
            M.toast({
              html: error.message,
              classes: "rounded",
              displayLength: 3000,
            });
          });

      this.dnReciclar = "";
      document.getElementById("dnReciclar").classList.remove("valid");
    },
    sendNoti() {
      sendNotification();
    },
    cambiarPlataforma() {
      cambiarEmpresa(this.noPlataforma == 2 ? 1 : 2)
          .then((resp) => {
            this.noPlataforma = this.noPlataforma == 2 ? 1 : 2;
            this.getMovements();
          })
          .catch((error) => {
            console.log(error);
          });
    },
    enviar() {
      if (this.tipoRecarga === "ICC") {
        if (!this.hasMoviDnPermit) this.telefono = "";
        if (this.icc.trim() === "" || this.icc.trim().length > 20)
          return (this.mensaje = " Introduce un icc valido");
        if (this.confirmacionIcc.trim() === "")
          return (this.mensaje = " Introduce la confirmación del icc ");
        if (this.confirmacionIcc !== this.icc)
          return (this.mensaje = "Los dos Icc no coinciden");
      } else {
        this.icc = "";
        if (this.telefono.trim() === "" || this.telefono.trim().length !== 10)
          return (this.mensaje = " Introduce un teléfono válido");
        if (this.confirmacionTel.trim() === "")
          return (this.mensaje = " Introduce la confirmación del teléfono ");
        if (this.confirmacionTel !== this.telefono)
          return (this.mensaje = "Los dos números no coinciden");
      }
      this.mensaje = " ";
      if (this.isRecargando)
        return (this.mensaje = "Ya se está realizando una recarga");
      this.isRecargando = true;
      this.$store.commit("ponerBarra");
      let objetoaEnviar = {};
      objetoaEnviar.icc = this.icc;
      objetoaEnviar.dn = this.telefono;
      objetoaEnviar.folio = this.folio;
      objetoaEnviar.origin = `web`;
      if (this.foreignOption) {
        recargaExterna(
            objetoaEnviar,
            this.companiaSeleccionada,
            this.montoSeleccionado,
            this.tipoPeticion
        )
            .then((respuesta) => {
              this.isRecargando = false;
              //this.getMovements()
              this.$store.commit("quitarBarra");
              let auxMessage = "Recarga externa generada exitosamente";
              if (respuesta.message) auxMessage = respuesta.mensaje;
              else if (respuesta.mensaje) auxMessage = respuesta.mensaje;
              this.mensaje = auxMessage;
              document.getElementById("player").play();
              M.toast({
                html: `${auxMessage}`,
                classes: "rounded",
                displayLength: 150000,
              });
              this.limpiar();
            })
            .catch((error) => {
              this.isRecargando = false;
              this.getMovements();
              this.$store.commit("quitarBarra");
              let auxMessage = "Recarga fallida";
              if (error.message) auxMessage = error.mensaje;
              else if (error.mensaje) auxMessage = error.mensaje;
              this.mensaje = auxMessage;
              document.getElementById("player").play();
              M.toast({
                html: `${auxMessage}`,
                classes: "rounded",
                displayLength: 150000,
              });
            });
        return true;
      }
      recargar(
          objetoaEnviar,
          this.companiaSeleccionada,
          this.montoSeleccionado,
          this.tipoPeticion
      )
          .then((respuesta) => {
            this.isRecargando = false;
            this.getMovements();
            this.$store.commit("quitarBarra");
            let auxMessage = "Recarga exitosa";
            if (respuesta.message) auxMessage = respuesta.mensaje;
            else if (respuesta.mensaje) auxMessage = respuesta.mensaje;
            this.mensaje = auxMessage;
            document.getElementById("player").play();
            M.toast({
              html: `${auxMessage}`,
              classes: "rounded",
              displayLength: 150000,
            });
            this.limpiar();
          })
          .catch((error) => {
            this.isRecargando = false;
            this.getMovements();
            this.$store.commit("quitarBarra");
            let auxMessage = "Recarga fallida";
            if (error.message) auxMessage = error.mensaje;
            else if (error.mensaje) auxMessage = error.mensaje;
            this.mensaje = auxMessage;
            document.getElementById("player").play();
            M.toast({
              html: `${auxMessage}`,
              classes: "rounded",
              displayLength: 150000,
            });
          });
    },
    limpiar() {
      this.telefono = "";
      this.confirmacionTel = "";
      this.icc = "";
      document.getElementById("telefono").classList.remove("valid");
      document
          .getElementById("confirmacion-telefono")
          .classList.remove("valid");
      document.getElementById("icc").classList.remove("valid");
      document.getElementById("confirmacion-icc").classList.remove("valid");
    },
    getMovements() {
      getMovimientos()
          .then((respuesta) => {
            this.movimientos = respuesta.movimientos;
            this.titulos = respuesta.titulos;
          })
          .catch((error) => {
            console.log(error);
          });
    },
  },
  computed: {
    ...mapState(["permisos", "isAdmin"]),
    isPlataformas() {
      console.log(this.permisos.includes(`PLATAFORMAS`) && this.isAdmin);

      return this.permisos.includes(`PLATAFORMAS`) && this.isAdmin;
    },

    isLineasRecicladas() {
      return this.permisos &&
          this.permisos.includes("RECICLAR_LINEAS")
          && this.isAdmin
    },
    isActivaciones() {
      return this.permisos &&
          this.permisos.includes("ACTIVACIONES_ATT")
          && this.isAdmin
    },
    sendMonto() {
      this.$nextTick(() => M.AutoInit());
      return this.permisos.includes(permisos.MONTO_LIDER);
    },
    hasMoviDnPermit() {
      return (
          this.permisos.includes(permisos.MOVI_DN) ||
          this.permisos.includes(permisos.ATT_DN)
      );
    },
    foreignRecharge() {
      return this.permisos.includes(permisos.RECARGA_EXTERNA);
    },
  },
};
</script>

<style scoped>

.wobble-hor-bottom:hover {
  -webkit-animation: pulsate-fwd 0.5s ease-in-out infinite both;
  animation: pulsate-fwd 0.5s ease-in-out infinite both;
}

@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}


.btn {
  width: 70px;
  text-align-last: center;
}

.btn-style {
  margin-top: 5px;
}

.icons-down {
  margin-left: -10px;
}

.titulo {
  font-size: 2.2em;
  display: block;
  margin-top: 5px;
  font-family: "Roboto", serif;
  font-weight: lighter;
}

.prefix {
  font-size: 1.4em;
  margin-top: 10px;
}

.card-panel {
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 10px;
  display: flow-root;
}

.icono-izquierda {
  left: 0;
}

.left {
  margin-left: 10px;
}

.recargas {
  width: 31%;
  margin-left: 3%;
}

.movimientos {
  width: 60%;
  margin-left: 3%;
  overflow-y: auto;
  max-height: 85vh;
}

.main {
  margin-top: 20px;
}

.mensaje-error {
  font-size: 1.5em;
  margin-bottom: 15px;
  font-family: "Roboto", serif;
  color: #b80009;
}

.radios {
  margin-left: 9%;
}

[type="radio"]:not(:checked) + span,
[type="radio"]:checked + span {
  float: left;
  color: black;
  font-size: 1.5em;
  margin-bottom: 8px;
}

td,
th {
  padding: 10px 5px;
}

.barraMovimientos {
  max-width: 100%;
  position: relative;
}

@media (max-width: 800px) {
  .recargas {
    width: 94%;
  }

  .movimientos {
    width: 94%;
  }
  .ultimos{
    display: none;
  }
}
</style>
